export function useChatBot() {
  const chatBotName = useProperty<string>('chatBotName');
  const enableChatBotForStudents = useProperty<boolean>('enableChatBotForStudents');

  return {
    chatBotName,
    enableChatBotForStudents
  };
}
